// extracted by mini-css-extract-plugin
export default {"Pager":"W5uOzsS3","PagerContent":"Qa8uDqK_","Shelf":"UGhtj7iM","sr-only":"ZENM7Qdp"};